import type { RefObject } from "react";
import { useLayoutEffect, useRef, useState } from "react";

type UseRefSizeReturn<T extends HTMLElement> = {
    ref: RefObject<T | null>;
    size: DOMRect | null;
};

/**
 * Provides a reference to a DOM element and returns its size and position (DOMRect).
 */
export const useRefSize = <T extends HTMLElement = HTMLDivElement>(): UseRefSizeReturn<T> => {
    const ref = useRef<T>(null);
    const [size, setSize] = useState<DOMRect | null>(null);

    useLayoutEffect(() => {
        if (ref.current) {
            setSize(ref.current.getBoundingClientRect());
        }
    }, []);

    return { ref, size };
};
